var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#21D0C3"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M225.137,59.203h194.584C476.103,106.163,512,176.886,512,256c0,141.385-114.615,256-256,256 c-32.174,0-62.958-5.953-91.327-16.789V135.085V70.122c0-6.004,4.909-10.914,10.914-10.914h49.55V59.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D2D4"
    },
    d: "M208.501,363.562h81.946v4.568h-81.946V363.562z M208.501,385.819h58.049v4.568h-58.049V385.819z  M208.501,374.693h81.946v4.563h-81.946V374.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D2D4"
    },
    d: "M357.872,363.562h81.946v4.568h-81.946L357.872,363.562L357.872,363.562z M357.872,385.819h58.049 v4.568h-58.049V385.819z M357.872,374.693h81.946v4.563h-81.946L357.872,374.693L357.872,374.693z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M345.881,266.457h105.927v84.21H345.881V266.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M196.51,266.457h105.927v84.21H196.51V266.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282"
    },
    d: "M175.592,59.203h244.13c11.894,9.908,22.872,20.872,32.798,32.747H164.673V70.122 c0-6.004,4.909-10.914,10.914-10.914L175.592,59.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M366.694,70.51h65.735c3.833,3.649,7.547,7.426,11.15,11.307H366.69 c-1.612,0-2.933-1.321-2.933-2.933v-5.441c0-1.612,1.321-2.933,2.933-2.933L366.694,70.51L366.694,70.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M186.446,68.561c3.473,0,6.286,2.813,6.286,6.286c0,3.473-2.813,6.286-6.286,6.286 s-6.286-2.813-6.286-6.286S182.973,68.561,186.446,68.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M211.258,68.561c3.473,0,6.286,2.813,6.286,6.286c0,3.473-2.813,6.286-6.286,6.286 c-3.473,0-6.286-2.813-6.286-6.286C204.972,71.374,207.784,68.561,211.258,68.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M236.07,68.561c3.473,0,6.286,2.813,6.286,6.286c0,3.473-2.813,6.286-6.286,6.286 c-3.473,0-6.286-2.813-6.286-6.286S232.597,68.561,236.07,68.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M189.235,103.955H461.96c27.994,37.86,45.796,83.702,49.366,133.491h-322.09V103.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M129.173,462.506c17.15-31.172,24.212-104.37,5.404-137.154s-12.527-36.1-54.048-35.86 c-41.038-0.028-35.246,3.025-54.099,35.786c-18.854,32.756-10.692,108.144,5.215,137.159c18.299,33.375,80.376,31.241,97.526,0.069 H129.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282"
    },
    d: "M145.366,368.97c-1.076-17.016-4.471-32.599-10.79-43.62c-18.807-32.784-12.527-36.1-54.048-35.86 c-41.038-0.028-35.246,3.03-54.099,35.786c-6.277,10.905-9.556,26.535-10.554,43.601L145.366,368.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M78.021,289.491l-0.056,79.429l5.312,0.005l0.056-79.443l-2.804,0.009l-2.508,0.005V289.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M80.666,304.929L80.666,304.929c-4.2-0.003-7.604,4.778-7.604,10.678v32.978 c0,5.9,3.404,10.685,7.604,10.688l0,0c4.2,0.003,7.604-4.778,7.604-10.678v-32.978C88.271,309.717,84.865,304.932,80.666,304.929z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M80.66,312.821L80.66,312.821c-3.623,0-6.56,2.928-6.56,6.541v25.487c0,3.613,2.937,6.541,6.56,6.541 l0,0c3.623,0,6.56-2.928,6.56-6.541v-25.487C87.221,315.749,84.283,312.821,80.66,312.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M133.972,283.611c-0.596,1.183-2.041,1.658-3.224,1.062c-1.183-0.596-1.663-2.041-1.062-3.229 l2.863-5.709c0.596-1.183,2.041-1.663,3.224-1.062c1.183,0.596,1.663,2.041,1.062,3.229L133.972,283.611z M125.183,281.26 c0.019,1.325-1.049,2.411-2.374,2.429c-1.325,0.014-2.411-1.049-2.429-2.374l-0.153-14.831c-0.019-1.325,1.049-2.411,2.374-2.429 c1.325-0.019,2.415,1.049,2.429,2.374L125.183,281.26z M115.714,283.057c0.721,1.109,0.406,2.596-0.707,3.317 s-2.596,0.406-3.317-0.707l-2.591-3.99c-0.721-1.113-0.406-2.596,0.707-3.317s2.596-0.406,3.317,0.707L115.714,283.057z  M135.939,310.085c-1.252-0.434-1.917-1.801-1.483-3.053c0.434-1.252,1.801-1.912,3.053-1.483l13.035,4.531 c1.252,0.434,1.917,1.801,1.483,3.053c-0.434,1.252-1.801,1.912-3.053,1.483L135.939,310.085z M140.406,300.188 c-1.288,0.295-2.577-0.517-2.868-1.805c-0.295-1.288,0.517-2.577,1.805-2.868l5.145-1.155c1.288-0.295,2.577,0.517,2.868,1.805 c0.295,1.288-0.517,2.577-1.805,2.868L140.406,300.188z M139.597,290.456c-1.03,0.836-2.545,0.684-3.381-0.346 c-0.836-1.03-0.679-2.545,0.351-3.381l8.887-7.27c1.03-0.836,2.545-0.684,3.381,0.346s0.684,2.545-0.346,3.381L139.597,290.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282"
    },
    d: "M78.796,289.491V162.169v-1.769h1.769h84.113v3.538H82.334v125.552L78.796,289.491L78.796,289.491z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteSvgrepoCom);
export default __webpack_public_path__ + "static/media/website-svgrepo-com.b3ae102d7470ac6a1615f8d3c3fcc541.svg";
export { ForwardRef as ReactComponent };